import { IchiTheme } from 'common/models/theme';
import React from 'react';
import { ThemeContext } from 'styled-components';

type Props = {
  className?: string;
};

const IchiLogo: React.FC<Props> = (props) => {
  const theme = React.useContext<IchiTheme>(ThemeContext);
  const className = props.className || 'h-10';
  return (
    <img src={theme.icons.sidebar} alt="ICHI logo" className={className} />
  );
};

export default IchiLogo;
